module.exports = __webpack_public_path__ + "static/Infants-4999ffa86db4493890601632849f19fd.png";